import type { CreditCardListSuccess } from "@b2bportal/card-api";
import { listPaymentMethods } from "@hopper-b2b/api";
import { CardPaymentSelectors } from "../";
import {
  type ParentContextWithCardPayment,
  PaymentErrorModalTypes,
} from "../types";

export const listPaymentMethodsService = (
  context: ParentContextWithCardPayment,
  _event: unknown
) =>
  new Promise((resolve, reject) => {
    const req = CardPaymentSelectors.getPaymentListRequest({
      context,
    });
    listPaymentMethods(req)
      .then((paymentMethods) => {
        resolve((paymentMethods as CreditCardListSuccess).value);
      })
      .catch((e) => {
        reject({
          type: PaymentErrorModalTypes.ListPaymentMethods,
          data: e,
        });
      });
  });
